import DataList from "../../../../component/DataList";

export default function RejectHistory() {
  return (
    <>
      <DataList
        url={"/erp/production-tasks/reject-history"}
        descriptions={[
          {
            fieldName: "produceOrderSerialNumber",
            fieldShowName: "订单单号",
            width: 120,
          },
          {
            fieldName: "workshopId",
            fieldShowName: "车间",
            width: 100,
            inputType: 6,
            dictionary: "erp_workshop",
          },
          {
            fieldName: "procedureId",
            fieldShowName: "工序",
            width: 100,
            inputType: 6,
            dictionary: "erp_procedure",
          },
          {
            fieldName: "radId",
            fieldShowName: "货品名称",
            width: 100,
            inputType: 6,
            dictionary: "rad_sku",
          },
          {
            fieldName: "model",
            fieldShowName: "规格",
            width: 100,
          },
          {
            fieldName: "color",
            fieldShowName: "表面处理",
            width: 100,
            inputType: 6,
            dictionary: "dict_rad_color",
          },
          {
            fieldName: "caliber",
            fieldShowName: "口径",
            width: 100,
            inputType: 6,
            dictionary: "dict_rad_caliber",
          },
          {
            fieldName: "userId",
            fieldShowName: "生产人员",
            width: 80,
            inputType: 8,
            dictionary: "base_staff_all",
          },
          {
            fieldName: "date",
            fieldShowName: "生产日期",
            width: 100,
            inputType: 4,
            format: "yyyy-MM-dd",
          },
          {
            fieldName: "totalCount",
            fieldShowName: "抽检数量",
            width: 50,
            inputType: 2,
          },
          {
            fieldName: "rejectCount",
            fieldShowName: "不良数量",
            width: 50,
            inputType: 2,
          },
          {
            fieldName: "remark",
            fieldShowName: "原因描述",
            width: 220,
          },
        ]}
      />
    </>
  );
}
